import logApi from '@/api/log'

export default {
  data() {
    return {
      cookies: {
        changeAddressName: 'change_address',
        changeMobileName: 'change_mobile'
      }
    }
  },
  methods: {
    async postLogApi(payload) {
      try {
        await logApi.postLog({
          body: payload
        })
      } catch (error) {
        console.error('Error Global Log API: ' + this.getErrorMessage(error))
      }
    },
    getErrorMessage(error) {
      return (
        error?.message ||
        error?.response?.data?.message ||
        error?.statusMessage ||
        JSON.stringify(error) ||
        error?.toString() ||
        error
      )
    },
    simplifyArray(value) {
      try {
        if (typeof value === 'string') return value
        if (!Array.isArray(value)) return value
        if (value.length === 0) return value
        const allSame = value.every((item) => item === value[0])
        return allSame ? value[0] : value
      } catch (error) {
        console.error('simplifyArray error:', error)
        return value
      }
    },
    cleanObject(input) {
      return Object.fromEntries(
        Object.entries(input).map(([key, value]) => [
          key,
          Array.isArray(value) ? [...new Set(value)][0] : value
        ])
      )
    },
    setCookie(name, value, days) {
      var expires = ''
      if (days) {
        var date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/'
    },
    getCookie(name) {
      var nameEQ = name + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    }
  }
}
